import { render, staticRenderFns } from "./TableLvl1.vue?vue&type=template&id=25bb5450"
import script from "./TableLvl1.vue?vue&type=script&lang=js"
export * from "./TableLvl1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports